module.exports = __webpack_public_path__ + "img/hero-01.152cbe0c.jpg";